import React from 'react';
import {
  AutocompleteArrayInput, CheckboxGroupInput, TextInput
} from 'react-admin';
import { ExpandMore } from '@material-ui/icons';
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FilterCardTitle from '../common/filters/FilterCardTitle';

const useStyles = makeStyles((theme) => ({
  dualGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '15px'
  },
  
  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },

  filterContainer: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: '20px'
  }
}));

const IABCategoryChoices = require('./iab_categories.json');
const googleCategoryChoices = require('./google_advertiser_verticals.json');
const blockedCreativeAttributes = require('./blockedCreativeAttributes.json');

const blockedAttributesChoices = Object.entries(blockedCreativeAttributes).map(e => ({id: e[0], name: e[1]}))

export function BlockedAttributesField({ record }) {
  return (
  <div>
    <br />
    <label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
      <span>Blocked Attributes</span>
    </label>
    {record.battr.map(item => (
      <li key={blockedCreativeAttributes[item]}>{blockedCreativeAttributes[item]}</li>
    ))}
  </div>
)};


export function AQRPage({permissions, record, ...props}) {
  const classes = useStyles(props);
  return (
    <>
      <Box className={classes.dualGrid} fullWidth>
        <Box className={classes.flexColumn} fullWidth>
          <Accordion className={classes.filterContainer}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <FilterCardTitle title='Blocked Creative Attributes' values={record.battr}/>
            </AccordionSummary>
            <AccordionDetails>
              <CheckboxGroupInput source="battr" label="" row={false} choices={blockedAttributesChoices} />
            </AccordionDetails>
          </Accordion>
          <Accordion className={classes.filterContainer}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <FilterCardTitle title='Blocked Creative IDs' values={record.bcrid}/>
            </AccordionSummary>
            <AccordionDetails>
              <TextInput multiline label="Blocked Creative IDs"
                source="bcrid"
                helperText="Format: CREATIVE_ID<NEW_LINE>CREATIVE_ID"
                fullWidth
              />
            </AccordionDetails>
          </Accordion>
          <Accordion className={classes.filterContainer} TransitionProps={{ timeout: 300 }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <FilterCardTitle title='Blocked Advertiser Domains' values={record.badv}/>
            </AccordionSummary>
            <AccordionDetails>
              <TextInput multiline label="Advertiser Domains"
                source="badv"
                helperText="Format: advertiserdomain1.com<NEW_LINE>advertiserdomain2.com"
                fullWidth
              />
            </AccordionDetails>
          </Accordion>
          <Accordion className={classes.filterContainer} TransitionProps={{ timeout: 300 }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <FilterCardTitle title='Allowed Advertiser Domains' values={record.aadv}/>
            </AccordionSummary>
            <AccordionDetails>
              <TextInput multiline label="Advertiser Domains"
                source="aadv"
                  helperText="List of advertiser domains that are NOT blocked because of a Catagory block. Format: advertiserdomain1.com<NEW_LINE>advertiserdomain2.com"
                fullWidth
              />
            </AccordionDetails>
          </Accordion>
        </Box>
        <Box className={classes.flexColumn} fullWidth>
          <Accordion className={classes.filterContainer}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <FilterCardTitle title='Blocked Advertiser Categories' values={record.bcat}/>
            </AccordionSummary>
            <AccordionDetails>
              <AutocompleteArrayInput label="Select the IAB categories to block"
                source="bcat"
                choices={IABCategoryChoices}
                style={{ minHeight: '80px', height: '80px' }}
                sort={{ field: 'id', order: 'ASC' }}
                fullWidth
              />
            </AccordionDetails>
          </Accordion>
          <Accordion className={classes.filterContainer}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <FilterCardTitle title='Blocked Google Advertiser Categories (Verticals)' values={record.bgcat}/>
            </AccordionSummary>
            <AccordionDetails>
              <AutocompleteArrayInput label="Select Google categories to block"
                source="bgcat"
                choices={googleCategoryChoices}
                style={{ minHeight: '80px', height: '80px' }}
                sort={{ field: 'id', order: 'ASC' }}
                fullWidth
              />
            </AccordionDetails>
          </Accordion>
          { permissions && permissions.role === 'admin' && 
            <Accordion className={classes.filterContainer}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title='Blocked Native Text' values={record.blocked_native_text}/>
              </AccordionSummary>
              <AccordionDetails>
                <TextInput multiline label="Blocked Native Text"
                  source="blocked_native_text"
                  helperText="Format: blocked native text<NEW_LINE>blocked native text<NEW_LINE>blocked native text"
                  fullWidth
                />
              </AccordionDetails>
            </Accordion>
          }
        </Box>
      </Box>
    </>
  )
}
